export class Finance {
  public static tenure_proportional_factor: number[] = [
    1.0, 0.92, 0.83, 0.75, 0.67, 0.58, 0.5, 0.42, 0.33, 0.25, 0.17, 0.08,
  ];
  public static proportional_factor_states: string[] = ["Estado de Mexico", "Ciudad de Mexico"];
  public static calculateTenure({ state, price, month = new Date().getMonth() }) {
    let tenure = 0;
    if (state.state === "Morelos") {
      if (price > 999999) tenure += 1000;
      return tenure;
    }
    tenure += state.tenure_car * price;
    if (this.proportional_factor_states.includes(state.state)) {
      return tenure * this.tenure_proportional_factor[month];
    }

    return tenure;
  }

  public static calculateTaxes({ state, price }) {
    let total_tax = 0;
    state.siting_taxes.forEach((tax) => {
      if (tax.calculation_type === "car_percentage") {
        total_tax += tax.value * price;
      } else if (tax.calculation_type === "fixed_amount") {
        total_tax += tax.value;
      }
    });
    return total_tax;
  }

  public static calculateStateRights({ state, price }) {
    if (state.rights_calculation_type === "car_percentage") {
      return state.state_rights * price;
    }
    return state.state_rights;
  }

  public static calculateTax({ tax, price }) {
    let total_tax = 0;
    if (tax.calculation_type === "car_percentage") {
      total_tax += tax.value * price;
    } else if (tax.calculation_type === "fixed_amount") {
      total_tax += tax.value;
    }
    return total_tax;
  }

  /**
   * Calculates tenure, taxes, state rights and totals for each siting state (quoter, plates dialog).
   */
  public static calcSitingTotals(
    states: any[],
    price: number,
    formatTenure: (amount: number) => string,
    options?: { tenureTaxPrice?: number }
  ): any[] {
    const rightsPrice = Number(price) || 0;
    const tenureTaxPrice =
      options?.tenureTaxPrice !== undefined && options.tenureTaxPrice !== null
        ? Number(options.tenureTaxPrice) || 0
        : rightsPrice;
    return states.map((raw) => {
      const state = {
        ...raw,
        siting_taxes: (raw.siting_taxes || []).map((t) => ({ ...t })),
      };
      const tenureVal = Number(Finance.calculateTenure({ price: tenureTaxPrice, state }));
      state.tenure = Number.isFinite(tenureVal) ? tenureVal : 0;
      const tenureTaxCar = Number(state.tenure_tax_car) || 0;
      if (state.tenure > 0) {
        const tenureWithTax = state.tenure + state.tenure * tenureTaxCar;
        state.amount_tenure = formatTenure(Number.isFinite(tenureWithTax) ? tenureWithTax : 0);
      } else {
        state.amount_tenure = "No aplica";
      }
      (state.siting_taxes || []).forEach((tax) => {
        const computed = Finance.calculateTax({ price: tenureTaxPrice, tax });
        tax.total = Number.isFinite(computed) ? computed : 0;
      });
      state.total_taxes = (state.siting_taxes || []).reduce((sum, tax) => sum + (Number(tax.total) || 0), 0);
      const rights = Finance.calculateStateRights({ state, price: rightsPrice });
      state.total_state_rights = Number.isFinite(rights) ? rights : 0;
      const homeDelivery = Number(state.home_delivery) || 0;
      let total = state.total_state_rights + homeDelivery;
      state.only_siting_cost = total;
      if (rightsPrice) {
        total += state.tenure + state.tenure * tenureTaxCar;
        total += state.total_taxes;
      }
      state.total = Number.isFinite(total) ? total : 0;
      return state;
    });
  }
}
